import '../css/style.scss';
import Glide from '@glidejs/glide'
import LightBox from '../../../rockhouse/src/js/popup/LightBox'
import rhGallery from './rh-gallery';


const galleries = document.querySelectorAll('.rh-gallery');
if(galleries) {
  galleries.forEach(gallery => rhGallery(gallery));
} 

const lightBox = new LightBox({
  beforeContentAppend : content => {
    content = content.replace(/iframe (.*?) (?:src=\"(.*?)\")/, "iframe $1 src=\"$2&autoplay=1\"");
    return content;
  }
});


const glides = document.querySelectorAll('.glide-slider');

var Example = function (Glide) {
  return {
    modify (translate) {
      const track = Glide.selector.querySelector('.glide__track');
      const slides = Glide.selector.querySelector('.glide__slides');
      const prevBtns = Glide.selector.closest('.glide-slider').querySelectorAll('[data-glide-go="<"],[data-glide-go="|<"]'); 
      prevBtns.forEach(btn => btn.classList.toggle('disabled',translate == 0));
      const nextBtns = Glide.selector.closest('.glide-slider').querySelectorAll('[data-glide-go=">"],[data-glide-go=">|"]'); 
      nextBtns.forEach(btn => btn.classList.toggle('disabled',translate +  track.clientWidth == slides.clientWidth));
      return translate;
    }
  }
}


if(glides) glides.forEach(glide => {
  const defaults = {
    swipeThreshold:20,
    bound:true,
    rewind: false,
    gap: "10px",
    breakpoints: {
      1000: {
        perView:1
      }
    }
  }
  const availableOptions = ['autoplay','gap','type','revind','perView','breakpoints'];
  const options = {};
  availableOptions.forEach(option => {
    let optionValue = glide.dataset[option];
    if(optionValue && option == "breakpoints") optionValue = JSON.parse(optionValue);
    if(glide.dataset.hasOwnProperty(option)) options[option] = optionValue ;
  })
  const glideContainer = glide.querySelector('.glide');
  const length = glideContainer.querySelectorAll('li').length;
  if(!glideContainer) return false;
  const gslider = new Glide(glideContainer, Object.assign(defaults,options));
  
  const controls = glide.querySelectorAll('[data-glide-go]');  
  controls.forEach(control => control.addEventListener('click',e=>{
    let action = control.dataset.glideGo;
    const index = parseInt(gslider._i);
    const total = gslider.selector.querySelectorAll('li').length;
    const perView = parseInt(gslider._o.perView);
    if(action == "|<") action = `=${  index - perView < 0 ? 0 : index - perView}`
    if(action == ">|") action = `=${  index + perView >= total - perView  ? total - perView : index + perView }`
    gslider.go(action);
    e.preventDefault();
  }))
  gslider.mutate([Example]).mount();
})

const mobileMenu = () => {
  const mainMenu = document.querySelector('nav#main ul');
  return () => document.body.classList.toggle('showMobileMenu',mainMenu.clientWidth < mainMenu.scrollWidth);
}

const addMobileMenuClass = mobileMenu();
addMobileMenuClass();
window.addEventListener('resize', addMobileMenuClass);

const menuTrigger = document.querySelectorAll(".menu__trigger, .menu-toggle");
menuTrigger.forEach(trigger => {
  trigger.addEventListener('click',e=>{
    e.preventDefault();
    e.stopPropagation();
    document.body.classList.toggle('menu-on');
  })
});

document.addEventListener('click', e => {
  document.body.classList.remove('menu-on');
})


var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


const header = document.getElementById('main-header');
const headerVideo = header ? header.querySelector('.header-video') : false;
let muted = header ? header.querySelector('.volume-toggle').classList.contains('muted') : false;

const videos = document.querySelectorAll('.videoPlayerCover');
function onYouTubeIframeAPIReady() {

  if(videos) videos.forEach((videoContainer,index) => {
    initVideo( videoContainer.querySelector('.videoFrame'),onPlayerReady )
  }); 

  if(headerVideo) initVideo(headerVideo, event => {
    const player = event.target;
    event.target.getIframe().classList.add('ready');
    console.log('add ready', headerVideo)
    if(muted) player.mute();
    player.setLoop(true);
    player.playVideo();  
    const volumeToggle = header.querySelector('.volume-toggle');
    volumeToggle.addEventListener('click', e => {
      muted = !muted;
      volumeToggle.classList.toggle('muted',muted)
      muted ? player.mute() : player.unMute();
    })
  }) 
  
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

function onPlayerReady(event) {
  event.target.getIframe().classList.add('ready');
}


const [videoWidth,videoHeight] = window.headerRatio.split(":");
window.addEventListener('resize', resizeVideo);

function initVideo(videoContainer, readyCb) {
  const videoId = videoContainer.dataset.videoId;
  if(!videoId) return false;
  let player = new YT.Player(videoContainer,{
    playerVars: {
      controls:0,
      playlist: [videoId],
      modestbranding:1,
      loop:1,  
      origin: window.location.href
    },
    videoId: videoId,
    events: {
      'onReady': readyCb,
    }
  })
  return player;
}

function resizeVideo() {
  if(! header) return false;
  const video = header.querySelector('.header-video');
  const {clientHeight:height,clientWidth:width} = header;
  
  const widthRatio = width/videoWidth;
  const heightRatio = height/videoHeight;

  const ratio = widthRatio > heightRatio ? widthRatio * aspectRatioFix : heightRatio * aspectRatioFix;
  
  video.style.width = `${videoWidth * ratio}px`;
  video.style.height = `${videoHeight * ratio}px`;
}
resizeVideo();


let currentVisibleElement = false;
const tracklistLyricsBtns = document.querySelectorAll('.tracklist__lyrics');
const tracklistLyricsCredits = document.querySelectorAll('.tracklist__credits');

const toggleElement = target => {
  if(currentVisibleElement) currentVisibleElement.classList.remove('active');
  if(target == currentVisibleElement) {
    currentVisibleElement = false;
    return;
  } else {
    target.classList.add('active');
    currentVisibleElement = target;
  }
}

if(tracklistLyricsBtns) tracklistLyricsBtns.forEach(lyricsBtn => {
  lyricsBtn.addEventListener('click', e => {
    e.preventDefault();
    const container =  e.target.closest('li');
    if(!container) return false;
    toggleElement( container.querySelector('.track__lyrics'));    
  })
});

if(tracklistLyricsCredits) tracklistLyricsCredits.forEach(creditsBtn => {
  creditsBtn.addEventListener('click', e => {
    e.preventDefault();
    const container =  e.target.closest('li');
    if(!container) return false;
    toggleElement(container.querySelector('.track__credits'));    
  })
});

